import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "../lib/api";

let cachedLogoUrl = null;

export default function BrandLogo({ className = "w-10 h-10", testid }) {
    const [logoUrl, setLogoUrl] = useState(cachedLogoUrl);

    useEffect(() => {
        if (cachedLogoUrl !== null) return;
        api.get("/content")
            .then((r) => {
                cachedLogoUrl = r.data.settings?.logo_url || "";
                setLogoUrl(cachedLogoUrl);
            })
            .catch(() => {
                cachedLogoUrl = "";
            });
    }, []);

    return (
        <Link to="/" title="Kembali ke Halaman Utama" className={`bg-racing-red flex items-center justify-center shrink-0 hover:bg-racing-redhover transition-colors ${className}`} data-testid={testid}>
            {logoUrl ? (
                <img src={fileUrl(logoUrl)} alt="Logo Mandalika Inlineskate" className="w-[80%] h-[80%] object-contain" />
            ) : (
                <span className="font-display text-white leading-none" style={{ fontSize: "55%" }}>M</span>
            )}
        </Link>
    );
}
